package com.downdogapp.client.views.playback

import com.downdogapp.*
import com.downdogapp.client.MediaPlayer
import com.downdogapp.client.View
import com.downdogapp.client.controllers.playback.PlaybackViewController
import com.downdogapp.client.resources.Image
import com.downdogapp.client.singleton.CastState

expect class PlaybackView(controller: PlaybackViewController) : View {

  fun updateTimelineVisibility()
  fun updatePoseImageTimelineVisibility()
  fun showSpinner()
  fun hideSpinner()
  fun onTimeChanged(time: Duration)
  fun play()
  fun pause()

  fun onViewLoaded()
  fun onPopped()
  fun onCastStateChanged(old: CastState, new: CastState)

  fun refreshView()

  fun addVideoPlayer(player: MediaPlayer)
  fun removeVideoPlayer(onExit: Boolean = false) // ios and android
  fun updateVideoFrame() // ios
  fun showVideo()
  fun hideVideo()
  fun showPoseConfirmation(text: String, image: Image)
  fun hidePoseConfirmation()

  fun scrollPoseImageTimeline(focusedImageIndex: Int, displayTime: Duration)
}

fun getVideoWidthAndHeight(screenWidth: Int,
                           screenHeight: Int,
                           videoWidthToHeight: Double): Pair<Int, Int> {
  val screenWidthToHeight = screenWidth / screenHeight.toDouble()
  return if (screenWidthToHeight > videoWidthToHeight) {
    (screenHeight * videoWidthToHeight).toInt() to screenHeight
  } else {
    screenWidth to (screenWidth / videoWidthToHeight).toInt()
  }
}
